import {SourceSession} from './SourceSession';
import {DestinationSession} from './DestinationSession';

export class DocumentSession {
  sourceSession: SourceSession;
  destinationSession: DestinationSession;
  movedBy: String;
  movedDateTime: String;
  status: String;

  public constructor(init?: Partial<DocumentSession>) {
    Object.assign(this, init);
  }
}
